/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { makeAsyncAction } from 'ui-lottery/src/utils/async_utils';
import * as api from '../api';
import * as types from '../constants/actions';

export const fetchPassType = makeAsyncAction(
    types.FETCH_PASS_TYPE,
    (passTypeId) => () => api.getPassType(passTypeId),
    'pass_type'
);

export const fetchPassTypes = makeAsyncAction(
    types.FETCH_PASS_TYPES,
    () => () => api.getPassTypes(),
    'pass_types'
);
